module.exports = __webpack_public_path__ + "images/bannerIT-1540cccd07810d323b206c30b489fc86.png";